export default __webpack_public_path__ + "static/media/requestTalent.20981ad2.svg";